export { environment } from './environment';



// WEBPACK FOOTER //
// ./src/environments/index.ts